module.exports = __webpack_public_path__ + "static/media/azureMobile.ff84ba2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/azureMobile.jpg
// module id = 854
// module chunks = 18